import {MasterOfActsAPI} from "../../api/api";
import { SearchSignature } from "../../components/ActFilling/ActFillingHeader/ActFillingHeader";
import { DynamicFields } from "../../utils/dynamicFields";
import { StackCheackFieldTemplate, StackField, makeActRaw } from "../../utils/stackField";
import { copyActThunk, setSelectedAct } from "./act-reducer";
import { setSelectedHandbook } from "./handbook-reducer";
import { loadingActiveEnvironmentState, setActiveEnvironmentState } from "./master-of-acts-reducer";
import DateTime from "luxon/src/datetime";

const SUCCESS_LOAD_ACT_TEMPLATE = 'actTemplateReducer/SUCCESS_LOAD_ACT_TEMPLATE'
const ERROR_LOAD_ACT_TEMPLATE = 'actTemplateReducer/ERROR_LOAD_ACT_TEMPLATE'
const SET_LOADING = 'actTemplateReducer/SET_LOADING'
const CLEAR_ACT_TEMPLATE = 'actTemplateReducer/CLEAR_ACT_TEMPLATE'
const LOCAL_SAVE_ACT_TEMPLATE = 'actTemplateReducer/LOCAL_SAVE_ACT_TEMPLATE'
const LOCAL_SEARCH_ACT_TEMPLATE = 'actTemplateReducer/LOCAL_SEARCH_ACT_TEMPLATE'
const START_COPY_ACT_TEMPLATE = 'actTemplateReducer/START_COPY_ACT_TEMPLATE'
const FINISHED_COPY_ACT_TEMPLATE = 'actTemplateReducer/FINISHED_COPY_ACT_TEMPLATE'
const ERROR_COPY_ACT_TEMPLATE = 'actTemplateReducer/ERROR_COPY_ACT_TEMPLATE'
const COPY_ACT_DATA = 'actTemplateReducer/COPY_ACT_DATA'

const initialState = {
    actTemplate: null,
    loading: true,
    error: null,
    dontSaveActTemplate: null,
    newSearch: null,
    copyStatus: false,
    copyActData: null
}

export const actTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUCCESS_LOAD_ACT_TEMPLATE:
            return {...state, actTemplate: action.actTemplate, loading: false}
        case ERROR_LOAD_ACT_TEMPLATE:
            return {...state, loading: false, error: 'Что-то пошло не так... Повторите позже'}
        case SET_LOADING:
            return {...state, loading: true}
        case CLEAR_ACT_TEMPLATE:
            return initialState
        case LOCAL_SAVE_ACT_TEMPLATE:
                return {
                    ...state,
                    dontSaveActTemplate: action.template
                }
        case LOCAL_SEARCH_ACT_TEMPLATE:
                return {
                    ...state,
                    newSearch: action.search
                }
        case START_COPY_ACT_TEMPLATE:
                return {
                    ...state,
                    copyStatus: true
                }
        case FINISHED_COPY_ACT_TEMPLATE:
                return {
                    ...state,
                    copyStatus: false
                }    
        case ERROR_COPY_ACT_TEMPLATE:
                return {
                    ...state,
                    copyStatus: action.error
                }  
        case COPY_ACT_DATA:
                return {
                    ...state,
                    copyActData: action.actData
                }                 
        default:
            return state
    }
}

export const getActTemplate = (state) => state.actTemplateReducer
export const getActTemplateField = (state) => state.actTemplateReducer.actTemplate.fieldTemplates
export const getActTemplateFieldLocal = (state) => state.actTemplateReducer.dontSaveActTemplate
export const getActTemplateFieldSearch = (state) => state.actTemplateReducer.newSearch

export const getActTemplateProject = (state) => state.actTemplateReducer.actTemplate.project
export const copyActData = (state) => state.actTemplateReducer.copyActData
export const copyStatus = (state) => state.actTemplateReducer.copyStatus

export const setCopyActData = (actData) => ({type: COPY_ACT_DATA, actData})

const setLoading = () => ({type: SET_LOADING})
export const successLoadActTemplate = (actTemplate) => ({type: SUCCESS_LOAD_ACT_TEMPLATE, actTemplate})
export const errorLoadActTemplate = () => ({type: ERROR_LOAD_ACT_TEMPLATE})
export const clearActTemplate = () => ({type: CLEAR_ACT_TEMPLATE})

export const setActTemplateValues = (template) => ({type: LOCAL_SAVE_ACT_TEMPLATE, template})
export const setActTemplateSearch = (search) => ({type: LOCAL_SEARCH_ACT_TEMPLATE, search})

export const startCopy = () => ({type: START_COPY_ACT_TEMPLATE})
export const finishedCopy = () => ({type: FINISHED_COPY_ACT_TEMPLATE})
export const errorCopy = (error) => ({type: ERROR_COPY_ACT_TEMPLATE, error})

export const loadingActTemplate = (actTemplateID) => async dispatch => {
    dispatch(setLoading())

    const actTemplate = await MasterOfActsAPI.getActTemplate(actTemplateID)
    if (actTemplate.status === 200) {
        const fieldTemplates = await MasterOfActsAPI.getFieldTemplates(actTemplateID)

        if (fieldTemplates.status === 200) {
            dispatch(successLoadActTemplate({
                id: actTemplate.data.id,
                content: actTemplate.data.content,
                project: actTemplate.data.project,
                fieldTemplates: fieldTemplates.data.map(el => ({
                    id: el.id,
                    type: el.type,
                    step: el.step,
                    helperText: el.help,
                    content: el.content,
                    variable: el.variable,
                    widthFieldXs: el.widthFieldXs,
                    format: el.format,
                    sequenceNumber: el.position_in_query,
                    label: el.name
                }))
            }))
        } else {
            dispatch(errorLoadActTemplate)
        }
    }
}


export const changeActTemplate = actTemplate => async dispatch => {
    dispatch(setLoading())

    const actTemplateResponse = await MasterOfActsAPI.updateActTemplate(actTemplate.id, {
        content: actTemplate.content,
        project: actTemplate.project
    })

    if (actTemplateResponse.status === 200) {
        const preparedFieldTemplates = actTemplate.fieldTemplates.map(
            (stepContent, stepIndex) =>
                stepContent.map(
                    el => ({
                        act_template: actTemplateResponse.data.id,
                        position_in_query: el.sequenceNumber,
                        help: el.helperText,
                        name: el.label,
                        content: el.content,
                        variable: el.variable,
                        widthFieldXs: el.widthFieldXs,
                        type: el.type,
                        step: stepIndex + 1,
                    }))).reduce((acc, curr) => {
                acc.push(...curr)
                return acc
            }, []
        )

        const fieldTemplatesResponse = await MasterOfActsAPI.createFieldTemplates(preparedFieldTemplates)

        if (fieldTemplatesResponse.status === 201) {
            dispatch(successLoadActTemplate({
                id: actTemplateResponse.data.id,
                content: actTemplateResponse.data.content,
                project: actTemplateResponse.data.project,
                fieldTemplates: fieldTemplatesResponse.data.map(el => ({
                    id: el.id,
                    type: el.type,
                    step: el.step,
                    helperText: el.help,
                    content: el.content,
                    variable: el.variable,
                    widthFieldXs: el.widthFieldXs,
                    format: el.format,
                    sequenceNumber: el.position_in_query,
                    label: el.name
                }))
            }))
        } else {
            dispatch(errorLoadActTemplate)
        }
    }
}



export const copyActContent = (projectId, selectAct, id) => {

    return async(dispatch) => {

            dispatch(startCopy())

            const stack = StackField()

            const currentTemplate = await MasterOfActsAPI.getCurrentActTemplate(projectId)

            const fieldTemplates = await MasterOfActsAPI.getFieldTemplates(currentTemplate.data.id)

            const activeEnviroment = await MasterOfActsAPI.getEnvironmentStates(null, projectId, null, null, true)

            const handbook = await MasterOfActsAPI.getHandbook(activeEnviroment.data[0].handbook)



            dispatch(setSelectedHandbook(handbook.data))
            dispatch(setActiveEnvironmentState(activeEnviroment.data[0]))
            dispatch(setSelectedAct(null))

            const fieldStack = StackCheackFieldTemplate(stack, fieldTemplates.data)   



            const violations = selectAct.violations

            let newViolations = []

            for (let i = 0; i  < violations.length; i++) {
                    
                const res = await MasterOfActsAPI.addViolation(
                        violations[i].name,
                        violations[i].content,
                        violations[i].raw_content,
                        activeEnviroment.data[0].id,
                        id,
                        violations[i].normative_articles,
                        violations[i].files,
                )

                newViolations = [...newViolations, ...[res.data]]
            }

            const newActRawContent = makeActRaw(fieldStack, selectAct, newViolations)

            dispatch(setCopyActData(newActRawContent))
            dispatch(successLoadActTemplate({
                    id: currentTemplate.data.id,
                    content: currentTemplate.data.content,
                    project: currentTemplate.data.project,
                    fieldTemplates: fieldTemplates.data.map(el => ({
                        id: el.id,
                        type: el.type,
                        step: el.step,
                        helperText: el.help,
                        content: el.content,
                        variable: el.variable,
                        format: el.format,
                        sequenceNumber: el.position_in_query,
                        label: el.name,
                        widthFieldXs: el.widthFieldXs

                    }))  
                })) 
            dispatch(finishedCopy())
    }
}


